"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dig = void 0;
/**
 * Retrieves a deeply nested value from an object at the given path.
 * @returns the referenced value if it exists, `undefined` if not.
 */
function dig(source, path) {
    if (typeof path === 'string') {
        return dig(source, path.split('.'));
    }
    if (typeof source !== 'object' || source === null) {
        return undefined;
    }
    if (path.length === 0) {
        return undefined;
    }
    const sourceRecord = source;
    if (path.length === 1) {
        return sourceRecord[path[0]];
    }
    return dig(sourceRecord[path[0]], path.slice(1, path.length));
}
exports.dig = dig;
//# sourceMappingURL=#dig.js.map